import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import 'reactjs-popup/dist/index.css';

if (import.meta.env.PROD) {
  import('./sw-cleanup').then((m) => m.cleanupLegacyServiceWorkers());
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
